import { ComponentType, ComponentInstance } from "./component";
import './table';

class Main extends ComponentInstance {
  scrollToSection() {
    const hash = window.location.hash;
    if (!hash) return;

    const navEntry = performance.getEntriesByType("navigation")[0];
    if (navEntry?.type === "reload") return;

    const target = document.querySelector(hash);
    if (!target) return;

    // Add tabindex only if required
    let addedTabindex = false;
    if (!target.hasAttribute("tabindex")) {
      target.setAttribute("tabindex", "-1");
      addedTabindex = true;
    }

    // Focus for SR + keyboard users
    target.focus({ preventScroll: true });
    target.classList.add("highlight");

    if (addedTabindex) {
      setTimeout(() => {
        target.removeAttribute("tabindex");
      }, 1000);
    }
  }

  init() {
    this.scrollToSection();
    // window.addEventListener('hashchange', this.#onHashChange);
  }

  remove() {
    // window.removeEventListener("hashchange", this.#onHashChange);
  }
}

new ComponentType(Main, "main", "body");
